if ( typeof ModalBox !== 'function' ) {

	class ModalBox extends HTMLElement {

		constructor() {

			window.inertElems = document.querySelectorAll('[data-js-inert]');

			super();
			this.o = {
				...{
					show: 10, 
					frequency: 'day', 
					enabled: true,
					showOnce: true,
					closeByKey: true,
					disableScroll: true,
					enableClose: false,
					blockTabNavigation: false,
					openedModalBodyClass: 'modal-opened',
				}, ...JSON.parse(this.dataset.options)
			};
			
			if ( this.o.smart && ! Shopify.designMode ) {

				// Newsletter-Pop-up: eigene Regeln, siehe initSmart()
				this.initStorage();
				this.initSmart();

			} else if ( this.o.enabled ) {

				this.initStorage();

				if ( this.isDue() ) {
					setTimeout(()=>{
						this.show();
					}, parseInt(this.o.show*1000));
					setTimeout(()=>{
						this.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{this.hide(this.o.showOnce)}));
					}, 100);
				}

			} else if ( this.o.enabled == false ) {
				this.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{this.hide(this.o.showOnce)}));
			}
			
			if ( this.o.enableClose == true ) {
				this.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{this.hide(this.o.showOnce)}));
			}

			if ( this.o.closeByKey ) {
				document.addEventListener('keydown', e=>{
					if ( e.keyCode == 27 ) {
						if ( this.classList.contains('active') ) {
							this.hide(this.o.showOnce);
						}
					}
				});
			}

		}

		initStorage(){
			this._modalKey = `modal-${document.location.hostname}-${this.id}`;
			this._modalStorage = ! localStorage.getItem(this._modalKey) ? 'empty' : JSON.parse(localStorage.getItem(this._modalKey));
			if ( this.querySelector('[data-content]') ) {
				this._modalText = this.querySelector('[data-content]').textContent;
			}
		}

		isDue(){
			const timeNow = new Date().getTime();
			const inBetween = Math.round((timeNow - this._modalStorage['shown']) / 1000);
			return this._modalStorage == 'empty'
				|| ( this.o.frequency == 'day' && inBetween > 86400 )
				|| ( this.o.frequency == 'week' && inBetween > 604800 )
				|| ( this.o.frequency == 'biweekly' && inBetween > 1209600 )
				|| ( this.o.frequency == 'month' && inBetween > 2419200 )
				|| this._modalStorage['content'] != this._modalText;
		}

		// Newsletter-Pop-up: erst ab der 2. Seitenansicht im Besuch, nie für Eingetragene.
		// Desktop: Exit-Intent oder nach "show" Sekunden. Mobil: ab 50 % Scrolltiefe
		// und frühestens nach "mobileDelay" Sekunden, als kompaktes Banner (CSS).
		initSmart(){

			const subscribedKey = `newsletter-subscribed-${document.location.hostname}`;
			const form = this.querySelector('form');

			let pageViews = 1;
			try {
				pageViews = ( parseInt(sessionStorage.getItem('ec-page-views')) || 0 ) + 1;
				sessionStorage.setItem('ec-page-views', pageViews);
			} catch(e) {}

			if ( new URLSearchParams(document.location.search).get('customer_posted') == 'true' ) {
				localStorage.setItem(subscribedKey, '1');
			}

			this.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{this.hide(this.o.showOnce)}));

			if ( ! this.o.enabled
				|| /^(\/[a-z]{2}(-[a-z]{2})?)?\/(cart|checkouts?|account|policies)(\/|$)/i.test(document.location.pathname)
			) {
				return;
			}

			const mobile = window.matchMedia('(max-width: 767px)').matches;
			if ( mobile ) {
				this.o.disableScroll = false;
			}

			// Zurück nach dem Absenden: Bestätigung bzw. Fehlermeldung sofort zeigen
			if ( form && document.location.hash == `#${form.id}` ) {
				this.show();
				return;
			}

			if ( localStorage.getItem(subscribedKey) || pageViews < this.o.minPageViews || ! this.isDue() ) {
				return;
			}

			let opened = false;
			const cleanup = [];
			const open = () => {
				if ( opened ) return;
				opened = true;
				cleanup.forEach(fn=>fn());
				this.show();
			}

			if ( ! mobile ) {

				const onLeave = e => {
					if ( ! e.relatedTarget && e.clientY <= 10 ) open();
				}
				document.addEventListener('mouseout', onLeave);
				const timer = setTimeout(open, parseInt(this.o.show*1000));
				cleanup.push(()=>document.removeEventListener('mouseout', onLeave), ()=>clearTimeout(timer));

			} else {

				let waited = false;
				const check = () => {
					const scrollable = document.documentElement.scrollHeight - window.innerHeight;
					const scrolled = scrollable <= 0 || window.scrollY / scrollable >= this.o.scrollDepth;
					if ( waited && scrolled ) open();
				}
				window.addEventListener('scroll', check, { passive: true });
				const timer = setTimeout(()=>{ waited = true; check(); }, parseInt(this.o.mobileDelay*1000));
				cleanup.push(()=>window.removeEventListener('scroll', check), ()=>clearTimeout(timer));

			}

		}

		show(){
			this.setAttribute('style', '');
			setTimeout(()=>{
				this.classList.add('active');
				if ( this.o.disableScroll ) {
					document.body.classList.add(this.o.openedModalBodyClass);
				}
				if ( this.o.blockTabNavigation ) {
					window.inertElems.forEach(elm=>{
						elm.setAttribute('inert', '');
					});
				}
			}, 10);
			setTimeout(()=>{
				if ( this.querySelector('[data-js-first-focus]') ) {
					this.querySelector('[data-js-first-focus]').focus();
				}
			}, 250);
		}

		hide(remember=false){
			this.classList.remove('active');
			document.body.classList.remove(this.o.openedModalBodyClass);
			setTimeout(()=>{
				this.style.display = 'none';
			}, 500);
			if ( remember && ! Shopify.designMode ){
				localStorage.setItem(this._modalKey, JSON.stringify({
					'shown': (new Date().getTime()),
					'content': this._modalText
				}));
			}
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			});
		}

	}

  if ( typeof customElements.get('modal-box') == 'undefined' ) {

		// Clone modal elements and move to end of body IF append-top-body
		
		const originalElements = document.querySelectorAll('modal-box');

		originalElements.forEach((originalElement) => {
			const dataOptions = JSON.parse(originalElement.dataset.options);
			if ( dataOptions.appendToBody === true ) {
				document.body.appendChild(originalElement);
			}
		});

		customElements.define('modal-box', ModalBox);

	}

	// Shopify events

	document.addEventListener('shopify:section:select', (e)=>{
		if ( e.target.classList.contains('mount-popup') ) {
			e.target.querySelector('modal-box').style.display = 'block';
			e.target.querySelector('modal-box').show();
		}
	});
	document.addEventListener('shopify:block:select', (e)=>{
		if ( e.target.hasAttribute('data-modal-box') ) {
			e.target.style.display = 'block';
			e.target.show();
		}
	});
	document.addEventListener('shopify:block:deselect', (e)=>{
		if ( e.target.hasAttribute('data-modal-box') ) {
			e.target.hide();
		}
	});
	document.addEventListener('shopify:section:deselect', (e)=>{
		if ( e.target.classList.contains('mount-popup') ) {
			e.target.querySelector('modal-box').hide();
		}
	});

}